class SizeGuide extends HTMLElement {
      constructor(){
        super();
        this._onClick = this._onClick.bind(this);
      }

      connectedCallback(){
        // click handler for delegated button clicks
        this.addEventListener('click', this._onClick);

        // determine default unit: 'in' or 'cm' (attribute data-default)
        const defaultUnit = (this.getAttribute('data-default') || 'in').toLowerCase();
        this._render(defaultUnit);

        // install global keyboard only once (controls all instances)
        if (!SizeGuide._keyboardInstalled) {
          document.addEventListener('keydown', (ev) => {
            if (ev.key === 'i' || ev.key === 'I') SizeGuide.setAll('in');
            if (ev.key === 'c' || ev.key === 'C') SizeGuide.setAll('cm');
          });
          SizeGuide._keyboardInstalled = true;
        }
      }

      disconnectedCallback(){
        this.removeEventListener('click', this._onClick);
      }

      // delegated click handler
      _onClick(e){
        const btn = e.target.closest('.btn-in, .btn-cm');
        if (!btn) return;
        // ensure the clicked button is inside this element
        if (!this.contains(btn)) return;
        const unit = btn.classList.contains('btn-in') ? 'in' : 'cm';
        this._render(unit);
      }

      // render requested unit inside this size-guide instance
      _render(unit){
        // toggle active classes on buttons within this element
        this.querySelectorAll('.btn-in, .btn-cm').forEach(btn => {
          const isInBtn = btn.classList.contains('btn-in');
          btn.classList.toggle('active', (unit === 'in' && isInBtn) || (unit === 'cm' && !isInBtn));
        });

        // update table cells inside this element only (prefer requested attribute, fallback to other)
        this.querySelectorAll('td[data-inch], td[data-cm]').forEach(td => {
          const inVal = td.getAttribute('data-inch') ?? '';
          const cmVal = td.getAttribute('data-cm') ?? '';
          td.textContent = (unit === 'in') ? (inVal || cmVal) : (cmVal || inVal);
        });

        // expose a simple event if other scripts need to listen
        this.dispatchEvent(new CustomEvent('sizeguide-change', {
          detail: { unit },
          bubbles: true,
          composed: true
        }));
      }

      // static helper to change all size-guides on page
      static setAll(unit){
        document.querySelectorAll('size-guide').forEach(el => el._render(unit));
      }
    }

    // register element
    customElements.define('size-guide', SizeGuide);


    // Toggle display between data-inch and data-cm values (no runtime conversion)
    const btnIn = document.getElementById('btn-in');
    const btnCm = document.getElementById('btn-cm');

    
    function setActiveButton(unit){
      btnIn?.classList.toggle('active', unit === 'in');
      btnCm?.classList.toggle('active', unit === 'cm');
    }

    function render(unit){
      setActiveButton(unit);
      // pick all table cells that have data-inch (canonical)
      document.querySelectorAll('td[data-inch], td[data-cm]').forEach(td=>{
        const inVal = td.getAttribute('data-inch');
        const cmVal = td.getAttribute('data-cm');
        if (unit === 'in'){
          td.textContent = inVal ?? cmVal ?? '';
        } else {
          td.textContent = cmVal ?? inVal ?? '';
        }
      });
    }

    btnIn?.addEventListener('click', ()=> render('in'));
    btnCm?.addEventListener('click', ()=> render('cm'));

    // initial state: inches
    render('in');

    // optional keyboard shortcuts: I / C
    document.addEventListener('keydown', (e)=>{
      if (e.key === 'i' || e.key === 'I') render('in');
      if (e.key === 'c' || e.key === 'C') render('cm');
    });